import { httpsCallable } from "firebase/functions";
import { conflict, err, inviteInvalid, networkError, notFound, ok, permissionDenied, } from "@pack-it-up/shared";
// Map a Cloud Functions HttpsError code to a DomainError — the ViewModel never sees a
// `functions/*` code. (firebase/functions surfaces the code as e.g. "functions/permission-denied".)
const mapCallableError = (e) => {
    const raw = e.code ?? "";
    const code = raw.replace(/^functions\//, "");
    switch (code) {
        case "permission-denied":
            return permissionDenied("perform this action");
        case "unauthenticated":
            return permissionDenied("sign in");
        case "not-found":
            return notFound("resource", "");
        case "failed-precondition":
        case "already-exists":
            return conflict(e.message ?? "Operation not allowed.");
        case "invalid-argument":
            return inviteInvalid();
        default:
            return networkError(e);
    }
};
// Invoke a callable and normalise to Result. The function's return shape is `Res`.
export const callFn = async (functions, name, data) => {
    try {
        const r = await httpsCallable(functions, name)(data);
        return ok(r.data);
    }
    catch (e) {
        return err(mapCallableError(e));
    }
};
//# sourceMappingURL=callable.js.map